<template>
    <div>
        <div class="serviceFee" v-if="venueInfo.service_fee && venueInfo.service_fee.amount">
            <input type="checkbox" id="checkboxServiceFee" v-model.lazy="checkboxServiceFee">
            <a target="_blank" >
                <label for="checkboxServiceFee">{{strings.serviceFee}} {{parseInt(venueInfo.service_fee.amount / 100)}} {{venueInfo.currency}} <a class="terms-link" href="https://meetingpackage.com/premium-service-terms" target="_blank" >{{strings.terms ? strings.terms.toLowerCase(): ''}}</a></label>
            </a>
        </div>
    </div>
</template>

<script>
import VModal from 'vue-js-modal'


export default {
    computed: {
        isBE() {
            return this.$store.state.isBE;
        },
        strings() {
            return this.$store.state.strings;
        },
        venueInfo(){
            return this.$store.state.venueInfo;
        },
      checkboxServiceFee: {
        get: function(){
          return this.$store.state.serviceFeeWithEnquiry;
        },
        set: function(serviceFeeWithEnquiry){
          this.$store.commit('setServiceFeeWithEnquiry', serviceFeeWithEnquiry);
        }
      },
    },
    methods: {
        showModal () {

                this.$modal.show({
                    template: `
                    <div>
                        <div class="v--modal-top-right"></div>
                            <div class="v--modal-box v--modal vue-dialog">
                            <div class="dialog-content">
                                <div class="dialog-c-title">{{title}}
                                    <div class="top-right" slot="top-right">
                            <button @click="$emit('close')">X</button>
                        </div>
                                </div>
                                <div class="dialog-c-text">
                                <div slot="text" v-html=text>{{text}}</div>
                        </div>
                        <div style="margin-top:25px;">
                        <button style="cursor:pointer;float:right" @click="$emit('close')"> {{close}}</button>
                        </div>	
                    </div>
                        </div>
                        </div>
        `,
                    props: ['text', 'title', 'close']
                }, {

                    text: this.$store.state.strings.serviceFeeText,
                    title: this.$store.state.strings.termsNConditions,
                    close: this.$store.state.strings.close

                }, {
                    height: 'auto'
                });
        }
    }
}
</script>

<style scoped>

    .serviceFee label {
        font-weight: 700;
        font-size: 12px;
        color: #323232;
        cursor:pointer;
    }
    .serviceFee{
        margin-bottom: 10px;
    }
    .terms-link {
        font-weight: 400;
        font-size: 12px;
        text-decoration: underline;
        color: #323232;
        cursor:pointer;
    }
</style>
